import React, { Component } from 'react';
import './Selection.css';
import {Button} from 'semantic-ui-react';

class Selection extends Component {
  handleClick(curr) {
    this.props.clickSelection(curr)
  }

  render() {
    if(this.props.mainState === this.props.link){
      return (
        <Button color="teal" onClick={()=>this.handleClick(this.props.link)}
          >{this.props.link}</Button>
      );
    }
    return (
      <Button basic
      onClick={()=>this.handleClick(this.props.link)}
      >{this.props.link}</Button>
    );
  }
}

export default Selection;



// WEBPACK FOOTER //
// ./src/Menu/Selection/Selection.js